import SkTechApiClient from "./base/SkTechApiClient";
import { ConfigApi } from "./base/ConfigApi";

export interface Currency {
    id: number;
    name: string;
    symbol: string;
    shortName: string;
    companyId: number;
    isMain: boolean;
}

export interface OperationCategory {
    id: number;
    name: string;
}

export interface OperationType {
    id: number;
    name: string;
    description: string;
    operationCategoryId: number;
    operationCategory?: OperationCategory;
    companyId: number;
}

export interface PaymentType {
    id: number;
    name: string;
    companyId: number;
}

export interface FinancialTransaction {
    id: number;
    name: string;
    description: string;
    amount: number;
    date: string;
    operationTypeId: number;
    operationType?: OperationType;
    paymentTypeId: number;
    paymentType?: PaymentType;
    currencyId: number;
    currency?: Currency;
    companyId: number;
    createdById?: number;
}

export interface PaginatedResult<T> {
    items: T[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export class CurrencyApiClient extends SkTechApiClient {
    constructor(c: ConfigApi) { super(c); }
    public async getAll() { return this.Get('/api/Currency'); }
    public async getById(id: number) { return this.Get(`/api/Currency/${id}`); }
    public async add(cur: Partial<Currency>) { return this.Post('/api/Currency', cur); }
    public async update(id: number, cur: Partial<Currency>) { return this.Put(`/api/Currency/${id}`, cur); }
    public async delete(id: number) { return this.Delete(`/api/Currency/${id}`); }
}

export class OperationTypeApiClient extends SkTechApiClient {
    constructor(c: ConfigApi) { super(c); }
    public async getAll() { return this.Get('/api/OperationType'); }
    public async getById(id: number) { return this.Get(`/api/OperationType/${id}`); }
    public async getCategories() { return this.Get('/api/OperationType/categories'); }
    public async add(o: Partial<OperationType>) { return this.Post('/api/OperationType', o); }
    public async update(id: number, o: Partial<OperationType>) { return this.Put(`/api/OperationType/${id}`, o); }
    public async delete(id: number) { return this.Delete(`/api/OperationType/${id}`); }
}

export class PaymentTypeApiClient extends SkTechApiClient {
    constructor(c: ConfigApi) { super(c); }
    public async getAll() { return this.Get('/api/PaymentType'); }
    public async getById(id: number) { return this.Get(`/api/PaymentType/${id}`); }
    public async add(p: Partial<PaymentType>) { return this.Post('/api/PaymentType', p); }
    public async update(id: number, p: Partial<PaymentType>) { return this.Put(`/api/PaymentType/${id}`, p); }
    public async delete(id: number) { return this.Delete(`/api/PaymentType/${id}`); }
}

export class FinancialTransactionApiClient extends SkTechApiClient {
    constructor(c: ConfigApi) { super(c); }
    
    // Original methods
    public async getAll() { return this.Get('/api/FinancialTransaction'); }
    public async getById(id: number) { return this.Get(`/api/FinancialTransaction/${id}`); }
    public async getByDateRange(s: string, e: string) { 
        return this.Get(`/api/FinancialTransaction/date-range?startDate=${s}&endDate=${e}`); 
    }
    public async add(t: Partial<FinancialTransaction>) { return this.Post('/api/FinancialTransaction', t); }
    public async update(id: number, t: Partial<FinancialTransaction>) { 
        return this.Put(`/api/FinancialTransaction/${id}`, t); 
    }
    public async delete(id: number) { return this.Delete(`/api/FinancialTransaction/${id}`); }
    public async getVersions(id: number) { return this.Get(`/api/FinancialTransaction/${id}/versions`); }
    public async rollback(id: number, vId: number) { 
        return this.Post(`/api/FinancialTransaction/${id}/rollback/${vId}`, {}); 
    }
    
    // New pagination method with direct query string passing
    public async getPaginated(queryString: string) { 
        console.log('API Request:', `/api/FinancialTransaction/paginated?${queryString}`);
        return this.Get(`/api/FinancialTransaction/paginated?${queryString}`); 
    }
    
    // Method for exporting all filtered transactions
    public async getForExport(queryString: string) {
        return this.Get(`/api/FinancialTransaction/export?${queryString}`);
    }

    public async getSummary(queryString: string) {
        console.log('API Request (summary):', `/api/FinancialTransaction/summary?${queryString}`);
        return this.Get(`/api/FinancialTransaction/summary?${queryString}`);
      }
}